// extracted by mini-css-extract-plugin
export default {"details_card":"feedback_details_card__GyQyx","sub_heading":"feedback_sub_heading__iALBN","text":"feedback_text__QPZUi","icons":"feedback_icons__MxGge"};